export default {"src":"/_next/static/media/dcm.9deeabe2.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};